module.exports = __webpack_public_path__ + "img/193.2d3dafa5.svg";